'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LayoutBoundary = require('./LayoutBoundary');

Object.defineProperty(exports, 'LayoutBoundary', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LayoutBoundary).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/layoutBoundary/index.js
// module id = 567
// module chunks = 0